import { Stack, Typography, Divider } from "@mui/material";
import { text, divider } from "@/theme/colors";
import { typography } from "@/theme/typography";
import { FC, ReactNode } from "react";

export type TSettingsSectionProps = {
  title?: string;
  children: ReactNode;
  hasDivider?: boolean;
};

export const SettingsSection: FC<TSettingsSectionProps> = ({ title, children, hasDivider = true }) => {
  return (
    <Stack gap={1}>
      {title && <Typography sx={{ ...typography.body14Semi, fontWeight: 700, color: text.primary }}>{title}</Typography>}

      {hasDivider && <Divider sx={{ borderColor: divider.middle }} />}

      {children}
    </Stack>
  );
};
